(function scrollProgressTimelineController(root) {
  function calculateTimelineState({ markers = [], timelineBottom = 0, timelineHeight = 0, triggerY = 0 } = {}) {
    if (!timelineHeight || markers.length === 0) {
      return { activeStep: 0, progress: 0 };
    }

    const firstMarker = markers[0];
    const lastMarker = markers[markers.length - 1];
    const markerTravel = lastMarker.viewportCenter - firstMarker.viewportCenter;
    const tailTravel = timelineBottom - lastMarker.viewportCenter;
    let fillHeight = 0;

    if (markerTravel > 0) {
      const markerProgress = (triggerY - firstMarker.viewportCenter) / markerTravel;

      if (markerProgress >= 1) {
        if (tailTravel > 0) {
          const tailProgress = (triggerY - lastMarker.viewportCenter) / tailTravel;

          if (tailProgress >= 1) {
            fillHeight = timelineHeight;
          } else if (tailProgress >= 0) {
            fillHeight = lastMarker.localCenter + ((timelineHeight - lastMarker.localCenter) * tailProgress);
          } else {
            fillHeight = lastMarker.localCenter;
          }
        } else {
          fillHeight = timelineHeight;
        }
      } else if (markerProgress >= 0) {
        fillHeight = firstMarker.localCenter
          + ((lastMarker.localCenter - firstMarker.localCenter) * markerProgress);
      }
    }

    const boundedFill = Math.min(Math.max(fillHeight, 0), timelineHeight);
    let activeStep = 0;

    markers.forEach((marker) => {
      if (boundedFill >= marker.localCenter) {
        activeStep = Math.max(activeStep, marker.step);
      }
    });

    return {
      activeStep,
      progress: Math.round((boundedFill / timelineHeight) * 10000) / 100,
    };
  }

  function createScrollProgressTimeline(config = {}) {
    return {
      activeStep: 0,
      activeStyle: String(config.initialStyle || ''),
      frame: null,
      progress: 0,

      init() {
        if (!this.activeStyle) {
          this.activeStyle = this.$el.dataset.initialStyle || '';
        }

        this.scheduleProgress();
      },

      destroy() {
        if (this.frame) {
          root.cancelAnimationFrame(this.frame);
          this.frame = null;
        }
      },

      scheduleProgress() {
        if (this.frame) {
          return;
        }

        this.frame = root.requestAnimationFrame(() => {
          this.frame = null;
          this.updateProgress();
        });
      },

      updateProgress() {
        const timeline = this.$refs.timeline;

        if (!timeline) {
          this.progress = 0;
          this.activeStep = 0;
          return;
        }

        const viewportHeight = root.innerHeight || root.document.documentElement.clientHeight;
        const triggerRatio = viewportHeight < 768 ? 0.6 : 0.55;
        const timelineRect = timeline.getBoundingClientRect();
        const timelineHeight = timeline.offsetHeight || timelineRect.height;
        const markerElements = Array.from(timeline.querySelectorAll('[data-scroll-progress-marker]'));
        const markers = markerElements.map((marker) => {
          const markerRect = marker.getBoundingClientRect();

          return {
            localCenter: markerRect.top - timelineRect.top + (markerRect.height / 2),
            step: Number(marker.dataset.scrollProgressMarker) || 0,
            viewportCenter: markerRect.top + (markerRect.height / 2),
          };
        });
        const state = calculateTimelineState({
          markers,
          timelineBottom: timelineRect.bottom,
          timelineHeight,
          triggerY: viewportHeight * triggerRatio,
        });

        this.progress = state.progress;
        this.activeStep = state.activeStep;
      },

      isStepActive(step) {
        return Number(step) <= this.activeStep;
      },
    };
  }

  function registerAlpine() {
    if (!root.Alpine) {
      return;
    }

    root.Alpine.data('scrollProgressTimeline', createScrollProgressTimeline);
  }

  if (root.document) {
    root.document.addEventListener('alpine:init', registerAlpine);
  }

  if (root.Alpine) {
    registerAlpine();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      calculateTimelineState,
      createScrollProgressTimeline,
    };
  }
})(typeof window !== 'undefined' ? window : globalThis);
